<p-dialog
  [(visible)]="visible"
  styleClass="checkout-dialog cardapio-dialog tilt-in-top-1"
  [modal]="true"
  [draggable]="false"
  [closable]="true"
  [dismissableMask]="true"
  [focusOnShow]="false"
  [blockScroll]="true"
  [showHeader]="false"
  [style]="{ width: 'min(600px, 96vw)', maxHeight: '92vh' }"
  (onShow)="onDialogShow()"
  (onHide)="onDialogHide()"
>
  <div class="checkout">
    <!-- Header -->
    <header class="checkout-header">
      <button class="checkout-voltar" type="button" (click)="onVoltar()">
        <i class="pi pi-arrow-left"></i>
      </button>
      <h2 class="checkout-titulo">{{ tituloTipoPedido }}</h2>
    </header>

    <div class="checkout-body">

      <!-- Resumo da conta (colapsavel) -->
      <div class="checkout-resumo-card">
        <div class="checkout-resumo-header" (click)="toggleResumo()">
          <span class="checkout-resumo-titulo">{{ 'cardapio_digital.checkout.resumo_conta' | translate }}</span>
          <i class="pi" [ngClass]="resumoExpandido ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </div>

        <!-- Itens expandidos -->
        <div class="checkout-resumo-itens" *ngIf="resumoExpandido">
          <div *ngFor="let item of itens; trackBy: trackByItem" class="checkout-resumo-item">
            <span class="checkout-resumo-qty">{{ item.quantidade }}x</span>
            <span class="checkout-resumo-nome">{{ item.produto.nome }}</span>
            <span class="checkout-resumo-preco">{{ formatarPreco(item.valorTotal) }}</span>
          </div>
        </div>

        <!-- Subtotal (sempre visivel) -->
        <div class="checkout-resumo-subtotal">
          <span>{{ totalItens }} {{ totalItens === 1 ? ('cardapio_digital.produto' | translate) : ('cardapio_digital.produtos' | translate) }}</span>
          <span class="checkout-resumo-subtotal-valor">{{ formatarPreco(subtotal) }}</span>
        </div>
      </div>

      <!-- Minhas informacoes (colapsavel) -->
      <div class="checkout-info-card">
        <div class="checkout-info-header" (click)="toggleInfo()">
          <span class="checkout-info-titulo">{{ 'cardapio_digital.checkout.minhas_informacoes' | translate }}</span>
          <i class="pi" [ngClass]="infoExpandido ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </div>

        <div class="checkout-info-body" *ngIf="infoExpandido">
          <div class="checkout-info-row">
            <div class="checkout-info-dados">
              <span class="checkout-info-nome">{{ nomeMascarado }}</span>
              <span class="checkout-info-telefone">{{ telefoneMascarado }}</span>
            </div>
            <button class="checkout-info-mudar" type="button" (click)="onVoltar()">
              {{ 'cardapio_digital.checkout.mudar' | translate }}
            </button>
          </div>
          <p class="checkout-info-seguranca">
            {{ 'cardapio_digital.checkout.minhas_info_seguranca' | translate }}
          </p>
        </div>
      </div>

      <!-- Endereco de entrega (apenas delivery) -->
      <div *ngIf="isDelivery && endereco" class="checkout-endereco-card">
        <div class="checkout-endereco-header">
          <span class="checkout-endereco-titulo">{{ 'cardapio_digital.checkout.endereco_entrega' | translate }}</span>
        </div>
        <div class="checkout-endereco-body">
          <i class="pi pi-map-marker checkout-endereco-icon"></i>
          <span class="checkout-endereco-texto">{{ endereco }}</span>
          <i class="pi pi-check-circle checkout-endereco-check"></i>
        </div>
      </div>

      <!-- Mesa e comanda (só no consumo no local): cada campo aparece apenas quando a loja o
           exige. O interruptor decide as duas coisas — aparece porque é obrigatório. -->
      <div *ngIf="exigeNumeroDaMesa" class="checkout-secao">
        <label class="checkout-label">
          {{ 'cardapio_digital.checkout.numero_mesa_titulo' | translate }}
          <span class="checkout-obrigatorio">*</span>
        </label>
        <input pInputText
               [(ngModel)]="numeroMesa"
               [placeholder]="'cardapio_digital.checkout.numero_mesa_placeholder' | translate"
               class="checkout-input" />
      </div>

      <div *ngIf="exigeNumeroDaComanda" class="checkout-secao">
        <label class="checkout-label">
          {{ 'cardapio_digital.checkout.numero_comanda_titulo' | translate }}
          <span class="checkout-obrigatorio">*</span>
        </label>
        <input pInputText
               [(ngModel)]="numeroComanda"
               [placeholder]="'cardapio_digital.checkout.numero_comanda_placeholder' | translate"
               class="checkout-input" />
      </div>

      <!-- Comentario -->
      <div class="checkout-secao">
        <textarea pInputTextarea
                  [(ngModel)]="comentario"
                  maxlength="1000"
                  [placeholder]="'cardapio_digital.checkout.comentario_placeholder' | translate"
                  [autoResize]="true"
                  [rows]="2"
                  class="checkout-textarea">
        </textarea>
      </div>

      <!-- Forma de pagamento. Some por inteiro quando a loja nao pergunta a
           forma de pagamento (configuracao do minishop). -->
      <div class="checkout-secao" *ngIf="exibirFormasPagamento">
        <label class="checkout-label">{{ 'cardapio_digital.checkout.forma_pagamento' | translate }}</label>
        <p class="checkout-pagamento-nota">{{ 'cardapio_digital.checkout.forma_pagamento_nota' | translate }}</p>
        <div class="checkout-pagamento-opcoes"
             role="radiogroup"
             [attr.aria-label]="'cardapio_digital.checkout.forma_pagamento' | translate">
          <button type="button"
                  *ngFor="let opcao of formasPagamento"
                  role="radio"
                  [attr.aria-checked]="formaPagamento === opcao.value"
                  class="checkout-pagamento-opcao"
                  [class.selecionada]="formaPagamento === opcao.value"
                  (click)="selecionarFormaPagamento(opcao.value)">
            <i class="pi checkout-pagamento-opcao-icone"
               [ngClass]="{
                 'pi-money-bill': opcao.value === 'DINHEIRO',
                 'pi-credit-card': opcao.value === 'CARTAO' || opcao.value === 'TARJETA',
                 'pi-qrcode': opcao.value === 'QR_CODE',
                 'pi-arrow-right-arrow-left': opcao.value === 'TRANSFERENCIA'
               }"></i>
            <span class="checkout-pagamento-opcao-label">{{ opcao.label }}</span>
          </button>
        </div>

        <!-- Pagamento pela Bancard (QR Code e cartao): o codigo nasce aqui, na propria escolha
             da forma, e o pedido so e criado quando o pagamento for confirmado. -->
        <!-- #blocoCobrancaQr: alvo do scroll automatico — o corpo do checkout rola sozinho ate
             o codigo (ou ate o botao de pagar com cartao) assim que a cobranca chega. -->
        <div *ngIf="cobraPorQrCode" class="checkout-qr" #blocoCobrancaQr>
          <div *ngIf="estadoCobrancaQr.gerando" class="checkout-qr-carregando">
            <i class="pi pi-spin pi-spinner"></i>
            <span>{{ (cobraPorCartao ? 'cardapio_digital.checkout.cartao_gerando' : 'cardapio_digital.checkout.qr_gerando') | translate }}</span>
          </div>

          <div *ngIf="estadoCobrancaQr.erro && !estadoCobrancaQr.gerando" class="checkout-qr-erro">
            <span>{{ estadoCobrancaQr.erro }}</span>
            <button type="button" class="checkout-qr-botao" (click)="tentarGerarQrNovamente()">
              {{ 'cardapio_digital.checkout.qr_tentar_novamente' | translate }}
            </button>
          </div>

          <!-- Cartao: a Bancard (tpago) devolve uma pagina de pagamento, nao um QR. -->
          <ng-container *ngIf="exibirLinkDeCartao && !estadoCobrancaQr.gerando">
            <p class="checkout-qr-instrucao">
              {{ 'cardapio_digital.checkout.cartao_instrucao' | translate }}
            </p>
            <p class="checkout-qr-valor">
              {{ formatarPreco(estadoCobrancaQr.cobranca?.valorDeCobranca || total) }}
            </p>
            <!-- Este e o passo do cliente: botao em destaque, na cor da loja. -->
            <button type="button"
                    class="checkout-qr-botao checkout-qr-botao--destaque"
                    (click)="abrirLinkDeCartao()">
              <i class="pi pi-credit-card"></i>
              {{ 'cardapio_digital.checkout.cartao_abrir_pagina' | translate }}
            </button>

            <div class="checkout-qr-status" *ngIf="!estadoCobrancaQr.confirmado">
              <i class="pi pi-spin pi-spinner"></i>
              <span>{{ 'cardapio_digital.checkout.qr_aguardando' | translate }}</span>
            </div>
            <div class="checkout-qr-status checkout-qr-status--confirmado" *ngIf="estadoCobrancaQr.confirmado">
              <i class="pi pi-check-circle"></i>
              <span>{{ 'cardapio_digital.checkout.qr_confirmado' | translate }}</span>
            </div>
          </ng-container>

          <ng-container *ngIf="exibirQrCode && !estadoCobrancaQr.gerando">
            <p class="checkout-qr-instrucao">
              {{ 'cardapio_digital.checkout.qr_instrucao' | translate }}
            </p>
            <img *ngIf="estadoCobrancaQr.cobranca?.urlQr"
                 class="checkout-qr-imagem"
                 [src]="estadoCobrancaQr.cobranca!.urlQr"
                 [alt]="'cardapio_digital.checkout.qr_instrucao' | translate" />
            <p class="checkout-qr-valor">
              {{ formatarPreco(estadoCobrancaQr.cobranca?.valorDeCobranca || total) }}
            </p>
            <button type="button"
                    class="checkout-qr-botao"
                    *ngIf="estadoCobrancaQr.cobranca?.qrData"
                    (click)="copiarCodigoQr()">
              <i class="pi pi-copy"></i>
              {{ 'cardapio_digital.checkout.qr_copiar_codigo' | translate }}
            </button>

            <div class="checkout-qr-status" *ngIf="!estadoCobrancaQr.confirmado">
              <i class="pi pi-spin pi-spinner"></i>
              <span>{{ 'cardapio_digital.checkout.qr_aguardando' | translate }}</span>
            </div>
            <div class="checkout-qr-status checkout-qr-status--confirmado" *ngIf="estadoCobrancaQr.confirmado">
              <i class="pi pi-check-circle"></i>
              <span>{{ 'cardapio_digital.checkout.qr_confirmado' | translate }}</span>
            </div>
          </ng-container>
        </div>

        <!-- Transferencia: a forma e oferecida, mas os dados bancarios da loja nao aparecem
             aqui — o cliente combina a transferencia com ela. -->
        <div *ngIf="isTransferencia" class="checkout-transferencia">
          <p class="checkout-transferencia-titulo">
            {{ texts.checkout?.transferencia_instrucao || 'A loja vai te passar os dados para a transferência.' }}
          </p>
        </div>

        <!-- Valor pago e troco (apenas quando Dinheiro selecionado) -->
        <div *ngIf="isDinheiro" class="checkout-troco-secao">
          <label class="checkout-label">
            {{ 'cardapio_digital.checkout.quanto_vai_pagar' | translate }}
          </label>
          <input pInputText
                 type="number"
                 [(ngModel)]="valorPago"
                 [placeholder]="'cardapio_digital.checkout.valor_pago_placeholder' | translate"
                 class="checkout-input"
                 min="0"
                 inputmode="numeric" />

          <!-- Resultado do troco -->
          <div *ngIf="trocoStatus" class="checkout-troco-resultado" [ngClass]="{
            'checkout-troco-positivo': trocoStatus === 'positivo' || trocoStatus === 'exato',
            'checkout-troco-insuficiente': trocoStatus === 'insuficiente'
          }">
            <ng-container [ngSwitch]="trocoStatus">
              <span *ngSwitchCase="'positivo'">
                {{ 'cardapio_digital.checkout.troco' | translate }}: {{ formatarPreco(trocoCalculado!) }}
              </span>
              <span *ngSwitchCase="'exato'">
                {{ 'cardapio_digital.checkout.sem_troco' | translate }}
              </span>
              <span *ngSwitchCase="'insuficiente'">
                {{ 'cardapio_digital.checkout.valor_insuficiente' | translate }}
              </span>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Frete (se delivery) -->
      <div *ngIf="isDelivery && frete > 0" class="checkout-frete-linha">
        <span>{{ 'cardapio_digital.checkout.frete' | translate }}</span>
        <span>{{ formatarPreco(frete) }}</span>
      </div>
      <div *ngIf="isDelivery && frete === 0" class="checkout-frete-linha">
        <span>{{ 'cardapio_digital.checkout.frete' | translate }}</span>
        <span class="checkout-frete-gratis">{{ 'cardapio_digital.checkout.frete_gratis' | translate }}</span>
      </div>

    </div>
  </div>

  <!-- Footer do dialog com botao confirmar -->
  <ng-template pTemplate="footer">
    <div class="checkout-footer">
      <button class="checkout-btn-confirmar" type="button"
              [disabled]="faltaMesaOuComanda || aguardandoPagamentoQr"
              (click)="onFinalizar()">
        <ng-container *ngIf="exibirRotuloAguardandoPagamento; else rotuloConfirmar">
          {{ 'cardapio_digital.checkout.qr_aguardando' | translate }}
        </ng-container>
        <ng-template #rotuloConfirmar>
          {{ 'cardapio_digital.checkout.confirmar_valor' | translate }} ({{ formatarPreco(total) }})
        </ng-template>
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-toast position="top-center"></p-toast>
